import { SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER } from "../../constants";
import { isDismissed } from "../../../../../services/notificationsOptIn";
import { getNotificationsPreference } from "../../../../../services/preferences";
import { PREFERENCE_STATUS } from "../../../../../services/preferences/constants";
import sdkInstanceProvider from "../../../../../providers/sdkInstanceProvider";
import { LoggedError } from "../../../../../services/errors";

const NOTIFICATIONS_OPT_IN_EXPERIMENT = "saved-lists-stock-alerts-optin";

// The features SDK is checked client side here (rather than server side) to avoid bucketing
// customers into the experiment before we know if they are eligible to see the banner.
const getExperimentBucket = async () => {
  const featuresSDK = await sdkInstanceProvider("features");
  await featuresSDK.onReady();
  const feature = featuresSDK.getFeature(NOTIFICATIONS_OPT_IN_EXPERIMENT);
  const isEnabled = await feature.isEnabled();
  if (!isEnabled) return null;
  const { bucket } = await feature.getVariables();

  return bucket;
};

export const initNotificationsOptInBanner = () => async dispatch => {
  if (isDismissed()) return;

  try {
    const status = await getNotificationsPreference();
    if (status === PREFERENCE_STATUS.NOT_OPTED_IN) {
      const bucket = await getExperimentBucket();
      if (bucket) {
        dispatch({
          type: SET_SHOW_NOTIFICATIONS_OPT_IN_BANNER,
          payload: { show: true, isSuccess: false, bucket }
        });
      }
    }
  } catch (e) {
    new LoggedError(e, LoggedError.error);
  }
};
